import { Card, CardContent } from "@/components/ui/card";
import { Users, Baby, BookOpen, TrendingUp } from "lucide-react";

interface Props {
  totalClasses: number;
  totalStudents: number;
  totalCapacity: number;
  avgOccupancy: number;
}

export default function ClassStatsCards({ totalClasses, totalStudents, totalCapacity, avgOccupancy }: Props) {
  const stats = [
    { label: "إجمالي الفصول", value: totalClasses, icon: BookOpen, color: "text-primary" },
    { label: "إجمالي الطلاب", value: totalStudents, icon: Baby, color: "text-emerald-500" },
    { label: "السعة الكلية", value: totalCapacity, icon: Users, color: "text-blue-500" },
    { label: "نسبة الإشغال", value: `${avgOccupancy}%`, icon: TrendingUp, color: avgOccupancy > 80 ? "text-red-500" : "text-amber-500" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((s) => (
        <Card key={s.label} className="shadow-card">
          <CardContent className="p-4 flex items-center gap-3">
            <div className={`p-2.5 rounded-xl bg-muted ${s.color}`}>
              <s.icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-2xl font-bold text-card-foreground">{s.value}</p>
              <p className="text-xs text-muted-foreground">{s.label}</p>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
